module.exports = __webpack_public_path__ + "img/zhys_zhTc.30b991bb.png";